import { useMutation, useQueryClient } from '@tanstack/react-query';

import { taskCommentsApi } from './api-handlers';
import { taskCommentsQueryKeys } from './query-keys';

import type { TCreateTaskCommentPayload } from '../model/types';

export const useCreateTaskCommentMutation = (taskId: string) => {
    const queryClient = useQueryClient();
    const queryKey = taskCommentsQueryKeys.list(taskId);
    return useMutation({
        mutationKey: taskCommentsQueryKeys.create(taskId),
        mutationFn: (payload: TCreateTaskCommentPayload) =>
            taskCommentsApi.createTaskComment({ taskId, payload }),
        onSuccess: async (data) => {
            await queryClient.cancelQueries({ queryKey, exact: true });
            queryClient.setQueryData(queryKey, data);
        },
    });
};
